import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../Button/Button.js';
import { Dropdown } from '../Dropdown/Dropdown.js';
export function ButtonDropdown({ id, className, iconLeft, sneaky, disabled, children, ...args }) {
    const color = sneaky ? 'light' : !iconLeft && !children ? 'white' : undefined;
    return (_jsx(Dropdown, { ...args, renderTrigger: (triggerRef, onOpenDropdown) => (_jsx(Button, { ref: triggerRef, className: className, iconLeft: iconLeft, iconRight: sneaky ? undefined : args.up ? 'chevronUp' : 'chevronDown', color: color, disabled: disabled, onMouseDown: (event) => {
                event.preventDefault();
                onOpenDropdown();
            }, children: children })) }));
}
//# sourceMappingURL=ButtonDropdown.js.map